import { Component } from '@theme/component';

class UtilityReadMoreComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.content = this.refs.content;
    this.toggleButton = this.refs.toggle;

    if (!this.content || !this.toggleButton) return;

    this.toggleButton.addEventListener('click', this.toggle.bind(this));

    // Force a check after a small delay to ensure styles and children are settled
    setTimeout(() => this.#checkOverflow(), 100);

    // Use ResizeObserver for more reliable overflow detection
    this.resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => this.#checkOverflow());
    });

    this.resizeObserver.observe(this.content);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  #checkOverflow() {
    // If we're already expanded, don't hide the button
    if (this.getAttribute('data-expanded') === 'true') return;

    // Line-clamp makes the element height smaller than scrollHeight if it overflows
    // We check both the content container and its immediate children (like rte-formatter)
    const candidates = [this.content, ...this.content.children];
    let isOverflowing = false;

    for (const el of candidates) {
      if (el.scrollHeight > el.offsetHeight + 2) {
        isOverflowing = true;
        break;
      }
    }

    if (isOverflowing) {
      this.toggleButton.classList.remove('hidden');
    } else {
      this.toggleButton.classList.add('hidden');
    }
  }

  toggle(event) {
    event.preventDefault();
    const isExpanded = this.getAttribute('data-expanded') === 'true';
    const nextState = !isExpanded;
    this.setAttribute('data-expanded', nextState);
    this.toggleButton.setAttribute('aria-expanded', nextState);

    // When expanding, we might need to recalculate or just leave it visible.
    // If we just collapsed, check overflow again in next frame.
    if (!nextState) {
      requestAnimationFrame(() => this.#checkOverflow());
    }
  }
}

if (!customElements.get('utility-read-more-component')) {
  customElements.define('utility-read-more-component', UtilityReadMoreComponent);
}
